export const ticketsTextReducer = (state = [], action) => {
  switch (action.type) {
    case "SET_TEXT_USER_TICKET":
      return action.payload;
    case "CLEAR_TEXT_USER_TICKET":
      return action.payload;
    default:
      return state;
  }
};
